import { Injectable } from '@angular/core';
import { ServerService } from './ServerService';
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class TaxasDeEntregaCalculadasService extends ServerService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  liste(inicio: number, total: number, filtro: string = 'todos', busca: string = '', dataInicial?: string, dataFinal?: string) {
    const params: any = {
      i: inicio,
      t: total,
      apenasEntregas: filtro === 'entregas',
      apenasFora: filtro === 'fora-area',
      busca: busca
    };
    
    if (dataInicial) params.dataInicial = dataInicial;
    if (dataFinal) params.dataFinal = dataFinal;
    
    return this.obtenha('/taxasDeEntregaCalculadas/liste', params);
  }
}
